import styled from "styled-components";

import { colors } from "@app/theme.ts";

export const CmtFilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  border: 1px solid ${colors.border};
  border-radius: 16px;
  background: ${colors.white};
`;
